import { ComparisonOperators, FovFieldTypes, FovNodeTypes, FovPageType, FovErrorType, FovErrorOption, FovErrorExperience, } from '@contentsquare/fov-constants';
// ANY PAGE
/**********CUSTOM*****************/
// User who visited any page and experienced any CUSTOM error
const anyCUSTOMErrorOnAnyPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyCUSTOMErrorOnAnyPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            field: 'customError:message',
            operator: 'exists',
            value: null,
            nodeType: 'filter',
        },
    },
    nodeType: 'filter',
};
// Users who visited any page and havent experienced any CUSTOM error
const anyCUSTOMErrorOnAnyPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.ANY,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyCUSTOMErrorOnAnyPageExclude = {
    child: {
        field: 'goal',
        operator: 'equals',
        value: {
            action: 'pageview',
            page: {
                field: 'customError:message',
                operator: 'exists',
                value: null,
                nodeType: 'filter',
            },
        },
        nodeType: 'filter',
    },
    nodeType: 'NOT',
};
// User who visited any page and experienced a named CUSTOM error that contains 'toto'
const namedCUSTOMErrorOnAnyPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        customErrorMessage: 'toto',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedCUSTOMErrorOnAnyPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            field: 'customError:message',
            operator: 'matches_regex',
            value: '(?i)(.*toto.*)',
            nodeType: 'filter',
        },
    },
    nodeType: 'filter',
};
// User who visited any page and havent experienced a named CUSTOM error that contains 'toto'
const namedCUSTOMErrorOnAnyPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        customErrorMessage: 'toto',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedCUSTOMErrorOnAnyPageExclude = {
    child: {
        field: 'goal',
        operator: 'equals',
        value: {
            action: 'pageview',
            page: {
                field: 'customError:message',
                operator: 'matches_regex',
                value: '(?i)(.*toto.*)',
                nodeType: 'filter',
            },
        },
        nodeType: 'filter',
    },
    nodeType: 'NOT',
};
// User who visited any page and experienced an exact CUSTOM error with details ...
const exactCUSTOMErrorOnAnyPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
        customErrorMessage: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
        customErrorAttributes: 'attr',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactCUSTOMErrorOnAnyPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'customError:message',
                    operator: 'equals',
                    value: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
                    nodeType: 'filter',
                },
                {
                    field: 'customError:attributes',
                    operator: 'contains',
                    value: 'attr',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// User who visited any page and havent experienced an exact CUSTOM error with details ...
const exactCUSTOMErrorOnAnyPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        customErrorMessage: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
        customErrorAttributes: 'attr',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactCUSTOMErrorOnAnyPageExclude = {
    child: {
        field: 'goal',
        operator: 'equals',
        value: {
            action: 'pageview',
            page: {
                children: [
                    {
                        field: 'customError:message',
                        operator: 'equals',
                        value: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
                        nodeType: 'filter',
                    },
                    {
                        field: 'customError:attributes',
                        operator: 'contains',
                        value: 'attr',
                        nodeType: 'filter',
                    },
                ],
                nodeType: 'AND',
            },
        },
        nodeType: 'filter',
    },
    nodeType: 'NOT',
};
// User who visited any page and experienced a grouped CUSTOM error 1234
const groupedCUSTOMErrorOnAnyPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.ANY,
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedCUSTOMErrorOnAnyPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            field: 'customError:groupId',
            operator: 'equals',
            value: '1234',
            nodeType: 'filter',
        },
    },
    nodeType: 'filter',
};
// User who visited any page and havent experienced a grouped CUSTOM error 1234
const groupedCUSTOMErrorOnAnyPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.ANY,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: undefined,
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedCUSTOMErrorOnAnyPageExclude = {
    child: {
        field: 'goal',
        operator: 'equals',
        value: {
            action: 'pageview',
            page: {
                field: 'customError:groupId',
                operator: 'equals',
                value: '1234',
                nodeType: 'filter',
            },
        },
        nodeType: 'filter',
    },
    nodeType: 'NOT',
};
// SPECIFIC PAGE
/**********CUSTOM*****************/
// Users who visited a specific page page1 and experienced any CUSTOM error
const anyCUSTOMErrorOnSpecificPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        customErrorMessage: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyCUSTOMErrorOnSpecificPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'customError:message',
                    operator: 'exists',
                    value: null,
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    nodeType: 'filter',
                    operator: 'equals',
                    value: '/page1',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific page page1 and havent experienced any CUSTOM error
const anyCUSTOMErrorOnSpecificPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorMessage: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyCUSTOMErrorOnSpecificPageExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: { field: 'page:path', operator: 'equals', value: '/page1', nodeType: 'filter' },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            { field: 'page:path', operator: 'equals', value: '/page1', nodeType: 'filter' },
                            { field: 'customError:message', operator: 'exists', value: null, nodeType: 'filter' },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// Users who visited a specific page page1 and experienced a named CUSTOM error that contains 'toto'
const namedCUSTOMErrorOnSpecificPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        customErrorMessage: 'toto',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedCUSTOMErrorOnSpecificPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'customError:message',
                    operator: 'matches_regex',
                    value: '(?i)(.*toto.*)',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific page page1 and havn't experienced a named CUSTOM error that contains 'toto'
const namedCUSTOMErrorOnSpecificPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        customErrorMessage: 'toto',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedCUSTOMErrorOnSpecificPageExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                field: 'page:path',
                                operator: 'equals',
                                value: '/page1',
                                nodeType: 'filter',
                            },
                            {
                                field: 'customError:message',
                                operator: 'matches_regex',
                                value: '(?i)(.*toto.*)',
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// Users who visited a specific page page1 and experienced an exact CUSTOM error with details ...
const exactCUSTOMErrorOnSpecificPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        customErrorMessage: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
        customErrorAttributes: 'attr',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactCUSTOMErrorOnSpecificPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    children: [
                        {
                            field: 'customError:message',
                            operator: 'equals',
                            value: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
                            nodeType: 'filter',
                        },
                        {
                            field: 'customError:attributes',
                            operator: 'contains',
                            value: 'attr',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific page page1 and havent experienced an exact CUSTOM error with details ...
const exactCUSTOMErrorOnSpecificPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        customErrorMessage: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
        customErrorAttributes: 'attr',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactCUSTOMErrorOnSpecificPageExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                field: 'page:path',
                                operator: 'equals',
                                value: '/page1',
                                nodeType: 'filter',
                            },
                            {
                                children: [
                                    {
                                        field: 'customError:message',
                                        operator: 'equals',
                                        value: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'customError:attributes',
                                        operator: 'contains',
                                        value: 'attr',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// Users who visited a specific page page1 and experienced a grouped CUSTOM error 1234
const groupedCUSTOMErrorOnSpecificPageInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedCUSTOMErrorOnSpecificPageInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'customError:groupId',
                    operator: 'equals',
                    value: '1234',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific page page1 and havent experienced a grouped CUSTOM error 1234
const groupedCUSTOMErrorOnSpecificPageExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.PAGE,
        mappingId: 1,
        pageId: 1,
        pageName: 'page1',
        pageUrl: undefined,
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedCUSTOMErrorOnSpecificPageExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/page1',
                    nodeType: 'filter',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                field: 'page:path',
                                operator: 'equals',
                                value: '/page1',
                                nodeType: 'filter',
                            },
                            {
                                field: 'customError:groupId',
                                operator: 'equals',
                                value: '1234',
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
/******************************************************************** */
// SPECIFIC URL
/**********CUSTOM*****************/
// Users who visited a specific URL and experienced any CUSTOM error
const anyCUSTOMErrorOnSpecificURLInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        customErrorMessage: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyCUSTOMErrorOnSpecificURLInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'page:host',
                    operator: 'equals',
                    value: 'www.ray-ban.com',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/usa/mobile/prescription-insurance-and-reimbursement',
                    nodeType: 'filter',
                },
                {
                    field: 'page:query',
                    operator: 'equals',
                    value: '',
                    nodeType: 'filter',
                },
                {
                    field: 'customError:message',
                    operator: 'exists',
                    value: null,
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific URL and havent experienced any CUSTOM error
const anyCUSTOMErrorOnSpecificURLExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.ANY,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        customErrorMessage: undefined,
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedAnyCUSTOMErrorOnSpecificURLExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    children: [
                        {
                            field: 'page:host',
                            operator: 'equals',
                            value: 'www.ray-ban.com',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:path',
                            operator: 'equals',
                            value: '/usa/mobile/prescription-insurance-and-reimbursement',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:query',
                            operator: 'equals',
                            value: '',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                children: [
                                    {
                                        field: 'page:host',
                                        operator: 'equals',
                                        value: 'www.ray-ban.com',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:path',
                                        operator: 'equals',
                                        value: '/usa/mobile/prescription-insurance-and-reimbursement',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:query',
                                        operator: 'equals',
                                        value: '',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                            {
                                field: 'customError:message',
                                operator: 'exists',
                                value: null,
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// Users who visited a specific URL and experienced a named CUSTOM error that contains 'toto'
const namedCUSTOMErrorOnSpecificURLInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        customErrorMessage: 'toto',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedCUSTOMErrorOnSpecificURLInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'page:host',
                    operator: 'equals',
                    value: 'www.ray-ban.com',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/usa/mobile/prescription-insurance-and-reimbursement',
                    nodeType: 'filter',
                },
                {
                    field: 'page:query',
                    operator: 'equals',
                    value: '',
                    nodeType: 'filter',
                },
                {
                    field: 'customError:message',
                    operator: 'matches_regex',
                    value: '(?i)(.*toto.*)',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// Users who visited a specific URL and havent experienced a named CUSTOM error that contains 'toto'
const namedCUSTOMErrorOnSpecificURLExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.NAMED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        customErrorMessage: 'toto',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedNamedCUSTOMErrorOnSpecificURLExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    children: [
                        {
                            field: 'page:host',
                            operator: 'equals',
                            value: 'www.ray-ban.com',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:path',
                            operator: 'equals',
                            value: '/usa/mobile/prescription-insurance-and-reimbursement',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:query',
                            operator: 'equals',
                            value: '',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                children: [
                                    {
                                        field: 'page:host',
                                        operator: 'equals',
                                        value: 'www.ray-ban.com',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:path',
                                        operator: 'equals',
                                        value: '/usa/mobile/prescription-insurance-and-reimbursement',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:query',
                                        operator: 'equals',
                                        value: '',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                            {
                                field: 'customError:message',
                                operator: 'matches_regex',
                                value: '(?i)(.*toto.*)',
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// User who visited a specific URL and experienced an exact CUSTOM error with details ...
const exactCUSTOMErrorOnSpecificURLInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.URL,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        customErrorMessage: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
        customErrorAttributes: 'attr',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactCUSTOMErrorOnSpecificURLInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'page:host',
                    operator: 'equals',
                    value: 'www.ray-ban.com',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/usa/mobile/prescription-insurance-and-reimbursement',
                    nodeType: 'filter',
                },
                {
                    field: 'page:query',
                    operator: 'equals',
                    value: '',
                    nodeType: 'filter',
                },
                {
                    field: 'customError:message',
                    operator: 'equals',
                    value: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
                    nodeType: 'filter',
                },
                {
                    field: 'customError:attributes',
                    operator: 'contains',
                    value: 'attr',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// User who visited a specific URL and havent experienced an exact CUSTOM error with details ...
const exactCUSTOMErrorOnSpecificURLExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.EXACT,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        customErrorMessage: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
        customErrorAttributes: 'attr',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedExactCUSTOMErrorOnSpecificURLExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    children: [
                        {
                            field: 'page:host',
                            operator: 'equals',
                            value: 'www.ray-ban.com',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:path',
                            operator: 'equals',
                            value: '/usa/mobile/prescription-insurance-and-reimbursement',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:query',
                            operator: 'equals',
                            value: '',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                children: [
                                    {
                                        field: 'page:host',
                                        operator: 'equals',
                                        value: 'www.ray-ban.com',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:path',
                                        operator: 'equals',
                                        value: '/usa/mobile/prescription-insurance-and-reimbursement',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:query',
                                        operator: 'equals',
                                        value: '',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                            {
                                children: [
                                    {
                                        field: 'customError:message',
                                        operator: 'equals',
                                        value: "Uncaught TypeError: Cannot read property 'indexOf' of undefined",
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'customError:attributes',
                                        operator: 'contains',
                                        value: 'attr',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
// User who visited a specific URL and experienced an exact CUSTOM error with details ...
const groupedCUSTOMErrorOnSpecificURLInclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.EXPERIENCED,
        pageOption: FovPageType.URL,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedCUSTOMErrorOnSpecificURLInclude = {
    field: 'goal',
    operator: 'equals',
    value: {
        action: 'pageview',
        page: {
            children: [
                {
                    field: 'page:host',
                    operator: 'equals',
                    value: 'www.ray-ban.com',
                    nodeType: 'filter',
                },
                {
                    field: 'page:path',
                    operator: 'equals',
                    value: '/usa/mobile/prescription-insurance-and-reimbursement',
                    nodeType: 'filter',
                },
                {
                    field: 'page:query',
                    operator: 'equals',
                    value: '',
                    nodeType: 'filter',
                },
                {
                    field: 'customError:groupId',
                    operator: 'equals',
                    value: '1234',
                    nodeType: 'filter',
                },
            ],
            nodeType: 'AND',
        },
    },
    nodeType: 'filter',
};
// User who visited a specific URL and havent experienced an exact CUSTOM error with details ...
const groupedCUSTOMErrorOnSpecificURLExclude = {
    field: FovFieldTypes.Error,
    operator: ComparisonOperators.MATCH_EQUALS,
    value: {
        errorType: FovErrorType.CUSTOM,
        errorOption: FovErrorOption.GROUPED,
        experienceOption: FovErrorExperience.HAVE_NOT_EXPERIENCED,
        pageOption: FovPageType.URL,
        mappingId: undefined,
        pageId: undefined,
        pageUrl: 'https://www.ray-ban.com/usa/mobile/prescription-insurance-and-reimbursement',
        errorGroupId: '1234',
    },
    nodeType: FovNodeTypes.FILTER,
};
const expandedGroupedCUSTOMErrorOnSpecificURLExclude = {
    children: [
        {
            field: 'goal',
            operator: 'equals',
            value: {
                action: 'pageview',
                page: {
                    children: [
                        {
                            field: 'page:host',
                            operator: 'equals',
                            value: 'www.ray-ban.com',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:path',
                            operator: 'equals',
                            value: '/usa/mobile/prescription-insurance-and-reimbursement',
                            nodeType: 'filter',
                        },
                        {
                            field: 'page:query',
                            operator: 'equals',
                            value: '',
                            nodeType: 'filter',
                        },
                    ],
                    nodeType: 'AND',
                },
            },
            nodeType: 'filter',
        },
        {
            child: {
                field: 'goal',
                operator: 'equals',
                value: {
                    action: 'pageview',
                    page: {
                        children: [
                            {
                                children: [
                                    {
                                        field: 'page:host',
                                        operator: 'equals',
                                        value: 'www.ray-ban.com',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:path',
                                        operator: 'equals',
                                        value: '/usa/mobile/prescription-insurance-and-reimbursement',
                                        nodeType: 'filter',
                                    },
                                    {
                                        field: 'page:query',
                                        operator: 'equals',
                                        value: '',
                                        nodeType: 'filter',
                                    },
                                ],
                                nodeType: 'AND',
                            },
                            {
                                field: 'customError:groupId',
                                operator: 'equals',
                                value: '1234',
                                nodeType: 'filter',
                            },
                        ],
                        nodeType: 'AND',
                    },
                },
                nodeType: 'filter',
            },
            nodeType: 'NOT',
        },
    ],
    nodeType: 'AND',
};
export const fovErrorSamplesCUSTOM = {
    anyCUSTOMErrorOnAnyPageInclude,
    expandedAnyCUSTOMErrorOnAnyPageInclude,
    anyCUSTOMErrorOnAnyPageExclude,
    expandedAnyCUSTOMErrorOnAnyPageExclude,
    namedCUSTOMErrorOnAnyPageInclude,
    expandedNamedCUSTOMErrorOnAnyPageInclude,
    namedCUSTOMErrorOnAnyPageExclude,
    expandedNamedCUSTOMErrorOnAnyPageExclude,
    exactCUSTOMErrorOnAnyPageInclude,
    expandedExactCUSTOMErrorOnAnyPageInclude,
    exactCUSTOMErrorOnAnyPageExclude,
    expandedExactCUSTOMErrorOnAnyPageExclude,
    groupedCUSTOMErrorOnAnyPageInclude,
    expandedGroupedCUSTOMErrorOnAnyPageInclude,
    groupedCUSTOMErrorOnAnyPageExclude,
    expandedGroupedCUSTOMErrorOnAnyPageExclude,
    anyCUSTOMErrorOnSpecificPageInclude,
    expandedAnyCUSTOMErrorOnSpecificPageInclude,
    anyCUSTOMErrorOnSpecificPageExclude,
    expandedAnyCUSTOMErrorOnSpecificPageExclude,
    namedCUSTOMErrorOnSpecificPageInclude,
    expandedNamedCUSTOMErrorOnSpecificPageInclude,
    namedCUSTOMErrorOnSpecificPageExclude,
    expandedNamedCUSTOMErrorOnSpecificPageExclude,
    exactCUSTOMErrorOnSpecificPageInclude,
    expandedExactCUSTOMErrorOnSpecificPageInclude,
    exactCUSTOMErrorOnSpecificPageExclude,
    expandedExactCUSTOMErrorOnSpecificPageExclude,
    groupedCUSTOMErrorOnSpecificPageInclude,
    expandedGroupedCUSTOMErrorOnSpecificPageInclude,
    groupedCUSTOMErrorOnSpecificPageExclude,
    expandedGroupedCUSTOMErrorOnSpecificPageExclude,
    anyCUSTOMErrorOnSpecificURLInclude,
    expandedAnyCUSTOMErrorOnSpecificURLInclude,
    anyCUSTOMErrorOnSpecificURLExclude,
    expandedAnyCUSTOMErrorOnSpecificURLExclude,
    namedCUSTOMErrorOnSpecificURLInclude,
    expandedNamedCUSTOMErrorOnSpecificURLInclude,
    namedCUSTOMErrorOnSpecificURLExclude,
    expandedNamedCUSTOMErrorOnSpecificURLExclude,
    exactCUSTOMErrorOnSpecificURLInclude,
    expandedExactCUSTOMErrorOnSpecificURLInclude,
    exactCUSTOMErrorOnSpecificURLExclude,
    expandedExactCUSTOMErrorOnSpecificURLExclude,
    groupedCUSTOMErrorOnSpecificURLInclude,
    expandedGroupedCUSTOMErrorOnSpecificURLInclude,
    groupedCUSTOMErrorOnSpecificURLExclude,
    expandedGroupedCUSTOMErrorOnSpecificURLExclude,
};
//# sourceMappingURL=fov-error.samples-custom.js.map